import { render } from "./ShowProcess.vue?vue&type=template&id=4aa297c6"
import script from "./ShowProcess.vue?vue&type=script&lang=js"
export * from "./ShowProcess.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/packing_house/production/final_packing_list_simplified/show_process.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fpacking_house%2Fproduction%2Ffinal_packing_list_simplified%2FShowProcess.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__